import type {GlobalConfig} from "./types";
import {PageType} from "./types";

export const GLOBAL_CONFIG: GlobalConfig = {
    mainSettings: {
        grade: "Русский язык. 3-4 класс",
        subject: "Изучение временных форм глагола в начальной школе: трудности и пути их преодоления",
        mainColor: "./images/bg_img.png",
        secondColor: "rgba(250, 219, 187, 0.8)",
    },
    home: {
        title: "Изучение временных форм глагола в начальной школе: трудности и пути их преодоления",
        authorsTitle: "Автор",
        authors: [
            {
                author: "Романова Владислава Юрьевна",
                grade: "кандидат педагогических наук, старший научный сотрудник лаборатории начального общего образования ФГБНУ «ИСРО»",
                subGrade: "",
                imageSrc: "./images/author1.png"
            }
        ],
        imagePath: "./images/title_img.png",
    },
    pages: [
        {
            order: 1,
            nextBtnName: "Далее",
            pdfPath: "./files/additional_information.pdf",
            type: PageType.ANNOTATION,
            imagePath: "",
            content: [
                {
                    type: "block",
                    children: [
                        {
                            type: "block",
                            text: `<div style='background: #E7F1FF; border-radius: 16px; padding: 2.4rem;'>
                                <p>Цель данного методического кейса — привлечь внимание к решению проблемы осознания младшими школьниками грамматических категорий глагола; показать, что основной причиной возникающих трудностей является использование учителем в основном репродуктивных методов обучения, которые не могут обеспечить предупреждение ошибок и проблем обучающихся. </p>
                                </div>
                                 <div style='padding: 2.4rem;'>
                                    <p>Методический кейс:</p>
                                    <ul>
                                    <li>сформирует готовность педагога к предупреждению трудностей при изучении глагола как части речи; </li>
                                    <li>подскажет методы наблюдения и анализа языковых единиц, способствующих пониманию обучающимися значения форм времени глагола. </li>
                                    <li>усовершенствует способность педагога к педагогической рефлексии.</li>
                                    </ul>
                                    </div>`
                        }
                    ]
                }
            ]
        },
        {
            order: 2,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "1011",
            title: "Практический модуль. Часть 1",
            htmlPath: "./interactive/dist1/index.html",
            autoHeight: false
        },
        {
            order: 3,
            nextBtnName: "Далее",
            type: PageType.METHODOLOGICAL_MODULE,
            title: "Методические рекомендации. Часть 1",
            imagePath: "",
            id: "1",
            videoUrl: "./video/video1.mp4"
        },
        {
            order: 4,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "1012",
            title: "Практический модуль. Часть 2",
            htmlPath: "./interactive/dist2/index.html",
            autoHeight: false
        },
        {
            order: 5,
            nextBtnName: "Далее",
            type: PageType.METHODOLOGICAL_MODULE,
            title: "Методические рекомендации. Часть 2",
            imagePath: "",
            id: "2",
            videoUrl: "./video/video2.mp4"
        },
        {
            order: 6,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "1013",
            title: "Практический модуль. Часть 3",
            htmlPath: "./interactive/dist3/index.html",
            autoHeight: false
        },
        {
            order: 7,
            nextBtnName: "Далее",
            type: PageType.ADDITIONAL_MATERIALS,
            imagePath: "",
            materials: [
                //   {link: "https://www.youtube.com/embed/CaaH2dUJqf8", title: "Последние загадки Гизы: египетские пирамиды"},
                //  {link: "https://www.youtube.com/embed/Mg7h_qYjs9k", title: "Тайна египетских пирамид Гизы"},
                //  {link: "https://www.youtube.com/embed/MVCTEz-2I0E", title: "Ленские столбы: заповедник"}
            ],
            literatures: [
                "Бондарко А.В. Вид и время русского глагола (значение и употребление). – Москва: Просвещение, 2002",
                "Волина В.В. Весёлая грамматика. – Москва: Знание, 1995",
                "Золотова Г.А. Аспекты изучения категории глагольного времени // Известия АН СССР. Серия литературного языка, 1975",
                "Современный русский язык. Морфология / Под ред. В.В.Виноградова. – Москва: Айрис-пресс, 2008",
            ],
            filesToDownload: [
                {
                    link: "./files/additional.pdf",
                    fileName: "Дополнительные задания, которые помогают реализовать потенциал анализа состава слов в обогащении словарного запаса"
                }
            ]
        }
    ],
};
